import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import StyledTextField from '../../../TextField';

export const StyledUsageContainerWrapper = styled(Box)(({ theme }) => ({
  gap: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const StyledHeaderAndLabelWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const StyledCurrentUsageTypography = styled(Typography)({
  fontSize: '18px',
  fontWeight: 500,
});

export const StyledFormContainer = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(5),
  gap: theme.spacing(2),
}));

export const StyledAppHeaderContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
});

export const StyledAppHeader = styled(CardHeader)({
  padding: 0,
  color: '#111827',
  '.MuiTypography-root': {
    fontWeight: 700,
  },
});

export const StyledAppSubHeader = styled(Typography)({
  color: '#6b7280',
});

export const StyledAppInner = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  gap: theme.spacing(3),
}));

export const StyledSecretKeyContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const StyledKeyTitle = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '28px',
  color: '#111827',
});

export const StyledKeyDescription = styled(Typography)({
  fontSize: '14px',
  lineHeight: '20px',
  color: '#6b7280',
});

export const StyledSecretKeyWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(1.5),
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}));

export const StyledSecretKeyField = styled(StyledTextField)(({ theme }) => ({
  flex: 1,
  backgroundColor: '#f3f4f6',
  border: 'none',
  borderRadius: theme.spacing(1),
  input: {
    textOverflow: 'ellipsis',
    fontSize: '14px',
  },
}));
